// extracted by mini-css-extract-plugin
export var stepActive = "_2q-3";
export var stepCompleted = "_2q-4";
export var stepConnectorLine = "_2q-b";
export var stepIndicatorCircle = "_2q-6";
export var stepIndicatorCircleCompleted = "_2q-7";
export var stepIndicatorCircleDefault = "_2q-8";
export var stepIndicatorTextCompleted = "_2q-9";
export var stepIndicatorTextDefault = "_2q-a";
export var stepPending = "_2q-5";
export var wizardContainer = "_2q-1";
export var wizardContent = "_2q-2";
export var wizardModal = "_2q-0";